import { ENABLE_AI_CHAT } from "../constants";
import { keys } from "../strings";

const DEBUG_FLAGS_EVENT = "finanslicenser-debug-flags-changed";

/** Default off — enable via env or localStorage (see readAiChatDebugFlag). */
export function readAiChatDebugFlag(): boolean {
  if (ENABLE_AI_CHAT) {
    return true;
  }
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return (
      window.localStorage.getItem(keys.localStorage.aiChatDebug) ===
      "true"
    );
  } catch {
    return false;
  }
}

export function writeAiChatDebugFlag(enabled: boolean): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    if (enabled) {
      window.localStorage.setItem(keys.localStorage.aiChatDebug, "true");
    } else {
      window.localStorage.removeItem(keys.localStorage.aiChatDebug);
    }
    window.dispatchEvent(new Event(DEBUG_FLAGS_EVENT));
  } catch {
    /* ignore quota / private mode */
  }
}

export function subscribeAiChatDebugFlag(
  listener: () => void
): () => void {
  if (typeof window === "undefined") {
    return () => undefined;
  }
  window.addEventListener(DEBUG_FLAGS_EVENT, listener);
  window.addEventListener("storage", listener);
  return () => {
    window.removeEventListener(DEBUG_FLAGS_EVENT, listener);
    window.removeEventListener("storage", listener);
  };
}
